<template>
  <div class="payment-edit-page">
    <sub-header-section :pageTitle="$tc('PaymentPage.EditPage.pageTitle')" />
    <payment-edit-pane />
  </div>
</template>

<script lang="ts">
import { defineComponent } from '@vue/composition-api'
import SubHeaderSection from '@/components/common/Header/SubHeaderSection.vue'
import PaymentEditPane from '@/components/pc/MyPage/PaymentPage/PaymentEditPane.vue'

/**
 * クレジットカード情報変更ページ
 */
export default defineComponent({
  name: 'PaymentEditPage',
  components: {
    SubHeaderSection,
    PaymentEditPane,
  },
})
</script>

<style lang="scss" scoped>
.payment-edit-page {
  &__header {
    position: sticky;
    top: 0;
  }
}
</style>
